import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';
import CountryService from '@/services/logistics/CountryService';

export default class CreateGiftingAddress {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * CountryService instance.
     *
     * @var {CountryService}
     */
    countryService

    /**
     * CreateGiftingAddress constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);
        this.countryService = new CountryService();

        this.apiService.enableAuth();
    }

    /**
     * Handle creating a new gifting address for the user's gifting address book.
     *
     * @param {*} payload
     *
     * @returns {Promise}
     */
    handle(payload) {
        let apiUrl = ApiEndpoints['gifting-addresses.store'];

        // Get the countries' name since vuex stores country iso.
        let giftingAddressCountry = CountryService.findCountryByIso(payload.country);

        let address = {
            first_name: payload.firstName,
            last_name: payload.lastName,
            address1: payload.address1,
            address2: payload.address2 || null,
            city: payload.city,
            country: giftingAddressCountry.name,
            postcode: payload.postcode,
            delivery_instructions: payload.deliveryComment,
            property_type: payload.propertyType,
        };

        return this.apiService.post(apiUrl, address);
    }
}
